import { api } from "common/config/api";

export const USERS_URL = {
	getUsers:`${api.withAPI}api/user`,
	getUser: `${api.withAPI}api/user`,
	updateUser: `${api.withAPI}api/user`,
	getFiles: `${api.withAPI}api/chat/file`,
}